import { takeLatest, put, fork } from "redux-saga/effects";
import { AxiosResponse } from "axios";
import {
  loadingPrescriberDetails,
  setPrescriberDetails,
} from "../Slice/PrescriberDetailsSlice";
import { PrecriberDetails } from "../../Apis/AuthApiServices";

function* onLoadPrescriberDetailsAsync({ payload }: any) {
  const params = new URLSearchParams();
  let LoginUserID: any = localStorage.getItem("LoginUserID");
  params.append("userId", LoginUserID);

  try {
    const result: AxiosResponse = yield PrecriberDetails(params);
    if (result?.status === 200) {
      yield put(
        setPrescriberDetails({
          AllPrescriberDetails: result?.data,
          error: false,
          isLoading: false,
        })
      );
    } else {
      yield put(
        setPrescriberDetails({
          AllPrescriberDetails: {},
          error: true,
          isLoading: false,
          message: result?.data?.digitalRxStatusMessage,
        })
      );
    }
  } catch (error) {
    yield put(
      setPrescriberDetails({
        AllPrescriberDetails: {},
        error: true,
        isLoading: false,
        message: "Try Again After Some Time!",
      })
    );
  }
}

function* onLoadPrescriberDetails() {
  yield takeLatest(loadingPrescriberDetails.type, onLoadPrescriberDetailsAsync);
}

const PrescriberDetailsSaga = [fork(onLoadPrescriberDetails)];

export default PrescriberDetailsSaga;
